module.exports = __webpack_public_path__ + "img/cannery-hall.d060f7f8.png";